import React, {useEffect, useState} from 'react';
import {Button, Flex, Input, List, Modal, Typography} from "antd";
import { ReactComponent as CrossIcon } from '../../../../../../assets/images/global-icons/cross_ic.svg'
import './CompanySearchModal.scss'
import '../../Profile-form.scss'
import {useNavigate} from "react-router";
import { googleMapsService } from '../../../../../../services/googleMaps';
const { Text } = Typography;

interface CompanySearchModalProps {
  visible: boolean;
  onClose: () => void;
  onCompanyClick: () => void;
  companyName: string;
  setCompanyName: (e: any) => void;
  handleCompanyClick: (placeId: string, companyName: string) => void;
  setIsCompanyListOpen: Function;
  isCompanyListOpen: boolean;
}

const CompanySearchModal: React.FC<CompanySearchModalProps> = (
  {onCompanyClick, onClose, visible, companyName, setCompanyName, handleCompanyClick, setIsCompanyListOpen, isCompanyListOpen}
) => {
  const [companies, setCompanies] = useState<any[]>([])
  const navigate = useNavigate();

  useEffect(() => {
    if (!companyName.trim()) {
      setCompanies([]);
      return;
    }

    googleMapsService.textSearch(companyName)
      .then((results) => {
        setCompanies(results);
      })
      .catch(() => {
        setCompanies([]);
      });
  }, [companyName]);

  return (
    <Modal open={visible} centered footer={null} closable={false} className="companySearchModal">
      <div className="companySearchModal_header">
        <Flex justify={"center"}>
          <Text className="companySearchModal_title">Choose a company</Text>
        </Flex>
        <CrossIcon className="companySearchModal_closeIcon" onClick={onClose}/>
      </div>
      <Flex vertical gap={'64px'} className="companySearchModal_content">
        <Flex vertical>
          <Text className="companySearchModal_subtitle">Enter your company name</Text>
          <Text className="companySearchModal_description">Please make sure to enter the full name of the company</Text>
        </Flex>
        <Flex vertical gap={'12px'} align={"start"}>
          <span className={'companySearchModal_input__label'}>Company name</span>
          <Input
            placeholder="Choose a company"
            className="companySearchModal_input"
            value={companyName}
            onChange={(e) => setCompanyName(e.target.value)}
            onFocus={() => setIsCompanyListOpen(true)}
          />

          {isCompanyListOpen && companyName.trim() && (
            <div className="personalCompany-search__results">
              <span>Result</span>
              <List
                dataSource={companies}
                locale={{
                  emptyText: (
                    <Flex vertical>
                      <Flex vertical className="personalCompany-search__empty">
                        <h3>No results found.</h3>
                        <p>We couldn't find any company that match your search</p>
                      </Flex>
                      <Flex className={"companyModal__empty__button"} justify={"center"}>
                        <Button type={'link'} onClick={onClose}>Try Another Search</Button>
                      </Flex>
                    </Flex>
                  ),
                }}
                renderItem={(company: any) => (
                  <List.Item
                    className="personalCompany-search__item"
                    onClick={() => handleCompanyClick(company.place_id, company.name)}
                  >
                    <span>{company.name}</span>
                    <p>{company.formatted_address}</p>
                  </List.Item>
                )}
              />
              {companies.length ? <p
                className="personalCompany-search__not-found"
                onClick={() => navigate('../personal/contact-us')}
              >
                Can’t find your company?
              </p> : ''}
            </div>
          )}
        </Flex>
      </Flex>
    </Modal>
  );
};

export default CompanySearchModal;